<template>
  <div class="stats-grid" :class="[`columns-${columns}`, `gap-${gap}`]">
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  columns?: number | 'auto';
  gap?: 'small' | 'medium' | 'large';
  minWidth?: string;
}

withDefaults(defineProps<Props>(), {
  columns: 'auto',
  gap: 'medium',
  minWidth: '150px',
});
</script>

<style scoped>
.stats-grid {
  display: grid;
  margin-bottom: 1.5rem;
}

/* Column configurations */
.columns-auto {
  grid-template-columns: repeat(auto-fit, minmax(v-bind(minWidth), 1fr));
}

.columns-1 {
  grid-template-columns: 1fr;
}

.columns-2 {
  grid-template-columns: repeat(2, 1fr);
}

.columns-3 {
  grid-template-columns: repeat(3, 1fr);
}

.columns-4 {
  grid-template-columns: repeat(4, 1fr);
}

.columns-5 {
  grid-template-columns: repeat(5, 1fr);
}

.columns-6 {
  grid-template-columns: repeat(6, 1fr);
}

/* Gap configurations */
.gap-small {
  gap: 0.5rem;
}

.gap-medium {
  gap: 1rem;
}

.gap-large {
  gap: 1.5rem;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .columns-auto,
  .columns-3,
  .columns-4,
  .columns-5,
  .columns-6 {
    grid-template-columns: 1fr 1fr;
  }

  .gap-medium {
    gap: 0.75rem;
  }

  .gap-large {
    gap: 1rem;
  }

  .stats-grid {
    margin-bottom: 1rem;
  }
}

@media (max-width: 480px) {
  .columns-auto,
  .columns-2,
  .columns-3,
  .columns-4,
  .columns-5,
  .columns-6 {
    grid-template-columns: 1fr;
  }
}
</style>
